import { TerminKalender } from '@/domain/termine/shared/types/TerminKalender';

export const OHNE_KALENDER_ID = 'NO_KALENDER';

export function defaultOhneKalender(
  kalender: TerminKalender[],
  t: (key: string) => string,
): TerminKalender[] {
  if (!kalender.some((k) => k.id === OHNE_KALENDER_ID)) {
    return [
      ...kalender,
      new TerminKalender({
        id: OHNE_KALENDER_ID,
        name: t('domain.termine.ohneCalendar'),
      }),
    ];
  }
  return kalender;
}
